/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Rename_File_DescriptionInputs */



/**
* | output |
* | --- |
* | "Only the name changes — the file keeps its type, its content and its search index." |
*
* @param {Spaces_Rename_File_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_rename_file_description = /** @type {((inputs?: Spaces_Rename_File_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Rename_File_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur der Name ändert sich – Typ, Inhalt und Suchindex der Datei bleiben erhalten.")
	return /** @type {LocalizedString} */ ("Only the name changes — the file keeps its type, its content and its search index.")
});